module.exports = __webpack_public_path__ + "static/media/hero-bcg7.6aafad0c.jpg";